import { api } from './api'
import { SceneDataProps } from '@/types/sceneProps'
import {
  type PaginatedResponseProps,
  normalizePaginationMeta,
} from '@/types/paginationProps'

export async function fetchScenesOptions(): Promise<SceneDataProps[]> {
  const firstPageResponse = await api.get<
    PaginatedResponseProps<SceneDataProps>
  >('/scenes', {
    params: {
      page: 1,
    },
  })

  const firstPageScenes = firstPageResponse.data.data
  const pagination = normalizePaginationMeta(
    firstPageResponse.data.meta,
    firstPageScenes.length,
  )

  if (pagination.lastPage <= 1) {
    return firstPageScenes
  }

  const nextPagesResponses = await Promise.all(
    Array.from({ length: pagination.lastPage - 1 }, (_, index) =>
      api.get<PaginatedResponseProps<SceneDataProps>>('/scenes', {
        params: {
          page: index + 2,
        },
      }),
    ),
  )

  return firstPageScenes.concat(
    nextPagesResponses.flatMap((response) => response.data.data),
  )
}
